const da = {
  common: {
    wallet: "wallet",
    playPage: "spil",
    minTop: "minimumsbeløbet er $10",
    maxTop: "maksimumsbeløbet er $500",
    website: "websted",
    signOut: "log ud",
    hidden: "skjult",
    victory: "sejr",
    wentWrong: "noget gik galt, omdirigerer",
    stakeLabel: "indsats",
    howDoes: "hvordan virker det?",
    continue: "Fortsæt",
    continueWithGoogle: "Fortsæt med Google",
    continueWithApple: "Fortsæt med Apple",
    termsOfService: "servicevilkår",
    privacyPolicy: "privatlivspolitik",
    termsOfServiceFooter: "servicevilkår",
    privacyPolicyFooter: "privatlivspolitik",
    verificationCode: "verifikationskode",
    verify: "bekræft",
    account: "konto",
    error: "der opstod en fejl\n",
    checkBackLater: "tjek tilbage senere",
    looking: "kigger...",
    yes: "ja",
    no: "nej",
    pleaseSelect: "Vælg venligst\n",
    disclaimer: "ved at fortsætte accepterer du vores\n",
    and: "og",
  },
  endOfGame: {
    wonByCheckmate: "vundet ved skakmat",
    lostOnTime: "tabt på tid",
    resigns: "opgiver",
    gameDrawnByAgreement: "spil uafgjort ved aftale",
    abandonedTheGame: "forlod spillet",
    gameAborted: "spil afbrudt",
    gameDrawnByStalemate: "spil uafgjort ved stalemate",
    gameDrawnByFiftyMoveRule: "spil uafgjort ved halvtreds træks regel",
    gameDrawnByInsufficientMaterial: "spil uafgjort på grund af utilstrækkeligt materiale",
    gameDrawnByThreefoldRepetition: "spil uafgjort ved trefoldig gentagelse",
    draw: "uafgjort",
    victory: "sejr",
    defeat: "nederlag",
    aborted: "afbrydes",
    white: "hvid",
    black: "sort",
    inspectBoard: "se bræt",
    returnToEndOfGameModal: "fortsæt",
  },
  byPhone:{
    continueOnPhone: "fortsæt på\ntelefon",
    or: "eller",
    continueOnWeb: "fortsæt på\nweb",
    disclaimer: "egnet hvis du har et billede af dit ID på disken"
  },
  signUp: {
    email: "email",
    username: "brugernavn",
    usernameInvalid: "ugyldigt brugernavn",
    emailInvalid: "ugyldig email",
    login: "log ind",
    continueWithPhone: "fortsæt med telefonnummer",
    tickBoxes: "lad os krydse nogle\nbokse af",
    confirm: "Jeg bekræfter, at\n",
    resideIn: "Jeg bor i\n",
    notPEP: "Jeg er ikke en politisk eksponeret person (PEP), et familiemedlem eller en kendt associeret af en PEP\n",
    purpose: "Formålet og karakteren af mit forhold til Gambit er udelukkende at bruge tjenesten til underholdning\n",
    soleBenefit: "Jeg vil bruge tjenesten udelukkende til min egen fordel, og der er ingen anden reel ejer\n",
  },
  identity: {
    beingVerified: "identitet\nbliver verificeret",
    verified: "verificeret\n",
    failed: "verifikation\nmislykkedes",
  },
  payment: {
    failed: "betaling mislykkedes.\nprøv venligst igen",
    successful: "betaling\nlykkedes!",
    toppedUp: "du er\nopfyldt!",
    topUp: "oplad\n",
    payWith: "betal med...\n",
  },
  gameplay: {
    play: "spil\n",
    challenge: "udfordrer dig til et",
    gameWorth: "spil værd\n",
    whatsYourNumber: "hvad er dit\nnummer?",
    receiveCode: "du vil snart modtage en verifikations\nkode",
    matchedOpponent: "Du matches med en modstander med lignende rating.",
    stake: {
      total: "Den samlede indsats vil være det beløb, der er valgt nedenfor.",
      contribution: "Du vil bidrage med cirka halvdelen af dette beløb.",
      weakerOpponent: "Hvis du matches mod en svagere modstander, vil du betale en større del af indsatsen.",
      strongerOpponent: "Hvis du matches mod en stærkere modstander, vil du betale en mindre del af indsatsen.",
    },
    supportInfo: "Besøg vores support for mere information.\n",
    continueBrowser: "fortsæt i\ndin browser",
    continuePhone: "fortsæt på\ntelefon",
    getStarted: "lad os komme\ni gang",
    sentText: "vi har sendt dig\nen tekst",
    enterReceivedCode: "indtast den modtagne\nverifikationskode",
    wrongCode: "forkert kode, prøv igen\n",
    secPerMove: "sek/træk",
    resign: {
      prompt: "er du sikker på, at du vil give op?",
    },
    draw: {
      offer: "accepter remis tilbud?",
    },
    rating: "rating\n",
    balance: "balance\n",
    rematch: "omkamp\n",
    newOpponent: "ny modstander\n",
    home: "hjem\n",
    rematchOffer: "din modstander tilbyder en omkamp. acceptere?",
    leaveGame: "Du spiller i øjeblikket et spil. Er du sikker på, at du vil forlade?",
    room: "rum:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Adrenalin skak. Du og din modstander får kun 1 minut hver til at vinde spillet.",
      },
      blitz: {
        title: "blitz\n",
        description: "Du og din modstander får 3 minutter hver til at vinde spillet.",
      },
    },
    stakes: {
      unlockNext: "spil {amount} flere spil for at låse op for den næste indsats",
      allUnlocked: "du har låst op for alle indsatser",
    },
    withdraw: "hæv\n",
  },
  puzzle: {
    begin: "begynde",
    next: "næste",
    unavailableInYourRegion: "utilgængelig",
    puzzle: "puslespil",
    whiteToPlay: "hvid ved draget",
    blackToPlay: "sort ved draget",
    time: "tid",
    solution: "løsning",
    somethingWentWrong: "noget gik galt",
    rating: "vurdering",
    credits: "kreditter",
    puzzleFailed: "tab",
    puzzleSolved: "sejr",
    correct: "korrekt løsning",
    incorrect: "forkert løsning",
    youRanOutOfTime: "du løb tør for tid",
    puzzleDescription: "Du har 10 sekunder + 2 sekunder/drag til at løse et puslespil.",
    creditsLeft: "tilbageværende kreditter",
    refillIn: "fyld op om",
    lastPuzzle: "Dette er dit sidste puslespil, kom tilbage senere for flere.",
    outOfCredits: "Du er løbet tør for kreditter, kom tilbage senere.",
    locationPrompt: "Vi har brug for din placering for at fortsætte. Hvis den er blokeret, skal du genaktivere den:",
    locationInstructions: "Klik på ikonet i adresselinjen, vælg 'Tillad altid' og opdater siden",
    creditsError: "Fejl ved indlæsning af kreditter",
    moves: "Træk:",
  },
};

export {da};